import { Route, Routes } from 'react-router-dom';
import './App.css';
import Map from '../Map/Map';

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path='map/:lat/:lon' element={<Map />} />
      </Routes>
    </div>
  );
}

export default App;
